import { createRouter, createWebHistory } from 'vue-router'
//import store from '@/store'
import NProgress from 'nprogress'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () =>
      import(
        /* webpackChunkName: "StoreLayout" */ '@/views/common/public/LayoutView.vue'
      ),
    children: [
      {
        path: '',
        name: 'home',
        component: () =>
          import(/* webpackChunkName: "HomeView" */ '@/views/HomeView.vue'),
      },
      {
        path: '/buy',
        name: 'buy',
        component: () =>
          import(/* webpackChunkName: "ContactView" */ '@/views/BuyView.vue'),
      },
      {
        path: '/sell',
        name: 'sell',
        component: () =>
          import(/* webpackChunkName: "ContactView" */ '@/views/SellView.vue'),
      },
      {
        path: '/promotions/:pageId?',
        name: 'promotions',
        props: (route) => ({ pageId: parseInt(route.params.pageId) || 0 }),
        component: () =>
          import(
            /* webpackChunkName: "ContactView" */ '@/views/PromotionsView.vue'
          ),
      },
      {
        path: '/contact',
        name: 'contact',
        component: () =>
          import(
            /* webpackChunkName: "ContactView" */ '@/views/ContactView.vue'
          ),
      },
      {
        path: '/signup',
        name: 'signup',
        component: () =>
          import(/* webpackChunkName: "SignupView" */ '@/views/SignupView.vue'),
      },
      {
        path: '/simule',
        name: 'simule',
        component: () =>
          import(/* webpackChunkName: "SimuleView" */ '@/views/SimuleView.vue'),
      },
      {
        path: '/politica',
        name: 'sigpoliticanup',
        component: () =>
          import(
            /* webpackChunkName: "PoliticaView" */ '@/views/PoliticaView.vue'
          ),
      },
      {
        path: '/termos',
        name: 'termos',
        component: () =>
          import(/* webpackChunkName: "TermosView" */ '@/views/TermosView.vue'),
      },
      {
        path: '/categories',
        name: 'categories',
        component: () =>
          import(
            /* webpackChunkName: "CategoriesView" */ '@/views/store/CategoriesView.vue'
          ),
      },
      {
        path: 'products/:pageId?',
        name: 'Products',
        props: (route) => ({ pageId: parseInt(route.params.pageId) || 0 }),
        component: () =>
          import(
            /* webpackChunkName: "StoreProducts" */ '@/views/store/ProductsView.vue'
          ),
      },
      {
        path: 'product/:title/:productId/:pageId?',
        name: 'Product',
        props: (route) => ({
          title: route.params.title || 'product_error',
          productId: parseInt(route.params.productId) || 0,
          pageId: parseInt(route.params.pageId) || 0,
        }),
        component: () =>
          import(
            /* webpackChunkName: "StoreProduct" */ '@/views/store/ProductView.vue'
          ),
      },
      {
        path: 'favoritos',
        name: 'Favoritos',
        component: () =>
          import(
            /* webpackChunkName: "FavoritosView" */ '@/views/store/FavoritosView.vue'
          ),
      },
    ],
  },

  {
    path: '/error',
    name: 'Errors',
    component: () =>
      import(
        /* webpackChunkName: "PublicLayout" */ '@/views/common/public/LayoutView.vue'
      ),

    children: [
      {
        path: '503',
        name: 'Error503',
        component: () =>
          import(
            /* webpackChunkName: "Error503" */ '@/views/errors/503View.vue'
          ),
      },
      {
        path: '404',
        name: 'Error404',
        component: () =>
          import(
            /* webpackChunkName: "Error404" */ '@/views/errors/404View.vue'
          ),
      },
    ],
  },
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'Error404' },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }

    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
